import { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const INITIAL_FORM = {
  departure: '',
  destination: '',
  date: '',
  time: '',
  passengers: '2',
  vehicle_type: '',
  protection: 'non',
  notes: '',
  phone: '',
  email: '',
};

const validateForm = (form, t) => {
  const errors = {};
  if (!form.departure.trim()) errors.departure = t('booking.errors.departure');
  if (!form.destination.trim()) errors.destination = t('booking.errors.destination');
  if (!form.date) errors.date = t('booking.errors.date');
  if (!form.time) errors.time = t('booking.errors.time');
  if (!form.phone.trim()) errors.phone = t('booking.errors.phone');
  if (!form.email.trim()) {
    errors.email = t('booking.errors.email_required');
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
    errors.email = t('booking.errors.email_invalid');
  }
  return errors;
};

const useBookingForm = (t) => {
  const [form, setForm] = useState(INITIAL_FORM);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const clearField = (name) => setForm(prev => ({ ...prev, [name]: '' }));

  const setField = (name, value) => setForm(prev => ({ ...prev, [name]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validateForm(form, t);
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setLoading(true);
    setApiError('');
    try {
      await axios.post(`${API}/reservations`, {
        ...form,
        passengers: parseInt(form.passengers, 10),
      });
      setSubmitted(true);
    } catch {
      setApiError(t('booking.error'));
    } finally {
      setLoading(false);
    }
  };

  return { form, errors, loading, submitted, apiError, handleChange, clearField, setField, handleSubmit };
};

export default useBookingForm;
